import { SendPhotosOptionsType } from './types';

export const SEND_PHOTOS_OPTIONS: SendPhotosOptionsType = [
  {
    id: 'no',
    title: 'No',
  },
  {
    id: 'yes',
    title: 'Yes',
  },
];
